import { render } from "./EditarFornecedor.vue?vue&type=template&id=fef25a02"
import script from "./EditarFornecedor.vue?vue&type=script&lang=js"
export * from "./EditarFornecedor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__